import React, { useState, useEffect } from 'react';
import "../application/application.css";
import HNavbar from '../../Components/Navbar/HNavbar';
import MFooter from '../../Components/Main-Footer/MFooter';

import app1 from "../../Assets/const-sites/cs-r3.jpg";
import app2 from "../../Assets/airports/airports-4.png";
import app3 from "../../Assets/hotels/Hotel-Sb.png";
import app4 from "../../Assets/road&rail/road&rail5.jpg";
import app5 from "../../Assets/generator-room/gr6.jpg";
import app6 from "../../Assets/oil-projects/oil-a7.jpg";
import app7 from "../../Assets/hospitals/hospital-3.png";
import app8 from "../../Assets/traffic-areas/traffic-areas-4.png";
import app9 from "../../Assets/sports/sports7.jpg";

function Application() {
    const [showTopBtn, setShowTopBtn] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);


    return (
        <>
            <HNavbar />
            {/* ===== HERO ===== */}
            <section className="app-sb-hero">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-xl-5">
                            <div className="app-hero-tag">OUR PRODUCT</div>
                            <h1 className="app-hero-title">
                                Effective Noise Control<br />
                                Across Environments
                            </h1>
                            <p className="app-hero-desc">
                                Our acoustic sound barrier systems are engineered to reduce noise pollution in a wide range of environments enhancing comfort, safety and quality of life.
                            </p>

                            <div className="d-flex flex-wrap gap-3 my-3 app-feature-icons-row">
                                {[
                                    {
                                        icon: "fa fa-solid fa-wave-square", label: "Up to 35 dB\nNoise Reduction"
                                    },
                                    { icon: "fa fa-solid fa-shield-halved", label: "Durable & Weather Resistant" },
                                    { icon: "fa fa-regular fa-clock", label: "Long Life Span\n15+ Years" },
                                    { icon: "fa fa-solid fa-globe", label: "Tested to Global Standards" },
                                ].map((f) => (
                                    <div className="app-feature-icon-item" key={f.label}>
                                        <i className={f.icon}></i>
                                        <span>{f.label}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section >

            {/* ===== CARD SECTION ===== */}
            <section className="sound-barrier-uses">
                <div className='container'>
                    <h2>Where Our Sound Barrier Systems Are Used</h2>
                    <div className="uses-grid">
                        <div className="use-card">
                            <div className="use-img">
                                <img src={app1} alt="Highways & Roads" />
                                <div className="use-icon"><i className="fa-solid fa-person-digging"></i></div>
                            </div>
                            <h4>Construction Sites</h4>
                            <p>Controls construction noise, ensuring compliance and community comfort.</p>
                        </div>

                        <div className="use-card">
                            <div className="use-img">
                                <img src={app2} alt="Railways & Metro" />
                                <div className="use-icon"><i className="fa-solid fa-plane"></i></div>
                            </div>
                            <h4>Airports</h4>
                            <p>Mitigates aircraft noise for nearby. communities and operations.</p>
                        </div>

                        <div className="use-card">
                            <div className="use-img">
                                <img src={app3} alt="Construction Sites" />
                                <div className="use-icon"><i className="fa-solid fa-city"></i></div>
                            </div>
                            <h4>Hotel</h4>
                            <p>Our hotel sound barrier solutions are designed to reduce noise disturbance and improve guest comfort.</p>
                        </div>

                        <div className="use-card">
                            <div className="use-img">
                                <img src={app4} alt="Industrial Facilities" />
                                <div className="use-icon"><i className="fa-solid fa-road"></i></div>
                            </div>
                            <h4>Highways & Roads</h4>
                            <p>Reduces traffic noise, creating qureter communities and safer environmenta</p>
                        </div>

                        <div className="use-card">
                            <div className="use-img">
                                <img src={app5} alt="Power Plants" />
                                <div className="use-icon"><i className="fa-solid fa-bolt"></i></div>
                            </div>
                            <h4>Generator Room</h4>
                            <p>Our systems are designed to reduce generator noise transmission and create a safer, quieter working environment.</p>
                        </div>

                        <div className="use-card">
                            <div className="use-img">
                                <img src={app6} alt="Airports" />
                                <div className="use-icon"><i className="fa-solid fa-industry"></i></div>
                            </div>
                            <h4>Oil and Gas Projects</h4>
                            <p>Sound barrier blankets reduce construction noise and limit public disruption.</p>
                        </div>

                        <div className="use-card">
                            <div className="use-img">
                                <img src={app7} alt="Urban Developments" />
                                <div className="use-icon"><i className="fa-solid fa-city"></i></div>
                            </div>
                            <h4>Hospital</h4>
                            <p>High-performance sound barriers for effective hospital noise control.</p>
                        </div>

                        <div className="use-card">
                            <div className="use-img">
                                <img src={app8} alt="Ports & Terminals" />
                                <div className="use-icon"><i className="fa-solid fa-truck"></i></div>
                            </div>
                            <h4>Traffic Areas</h4>
                            <p>Control traffic noise with durable outdoor acoustic barrier systems.</p>
                        </div>

                        <div className="use-card">
                            <div className="use-img">
                                <img src={app9} alt="Educational Institutions" />
                                <div className="use-icon"><i className="fa-solid fa-graduation-cap"></i></div>
                            </div>
                            <h4>Sports Events</h4>
                            <p>Professional acoustic solutions for controlling noise in sports arenas and event venues.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section class="why-choose-us">
                <div class="wcu-grid">
                    <div class="wcu-item">
                        <div class="wcu-icon"><i class="fa-solid fa-drafting-compass"></i></div>
                        <div class="wcu-text">
                            <h4>Customizable Solutions</h4>
                            <p>Designed to meet the specific noise control needs of every project.</p>
                        </div>
                    </div>

                    <div class="wcu-item">
                        <div class="wcu-icon"><i class="fa-solid fa-layer-group"></i></div>
                        <div class="wcu-text">
                            <h4>High Performance Materials</h4>
                            <p>Advanced multi-layer construction for maximum acoustic efficiency and durability.</p>
                        </div>
                    </div>

                    <div class="wcu-item">
                        <div class="wcu-icon"><i class="fa-solid fa-gear"></i></div>
                        <div class="wcu-text">
                            <h4>Easy &amp; Fast Installation</h4>
                            <p>Modular design allows quick installation with minimal site disruption.</p>
                        </div>
                    </div>

                    <div class="wcu-item">
                        <div class="wcu-icon"><i class="fa-solid fa-leaf"></i></div>
                        <div class="wcu-text">
                            <h4>Sustainable &amp; Recyclable</h4>
                            <p>Eco-friendly materials that support green building and sustainability goals.</p>
                        </div>
                    </div>

                    <div class="wcu-item">
                        <div class="wcu-icon"><i class="fa-solid fa-headset"></i></div>
                        <div class="wcu-text">
                            <h4>Technical Support</h4>
                            <p>Expert guidance from design to installation and after-sales support.</p>
                        </div>
                    </div>

                </div>
            </section>

            {showTopBtn && (
                <button className='scroll-to-top'
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                > ↑ </button>
            )
            }
            <MFooter />
        </>
    )
}

export default Application